import { render, staticRenderFns } from "./WorkstationScreenCanvas.vue?vue&type=template&id=233691b8"
import script from "./WorkstationScreenCanvas.vue?vue&type=script&lang=js"
export * from "./WorkstationScreenCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports